export const PENDING = 'Pending';
export const IN_PROGRESS = 'In Progress';
export const COMPLETED = 'Completed';
